var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-426 -958)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-216.109,694.4a12.014,12.014,0,0,0-12,12,12.014,12.014,0,0,0,12,12,12.013,12.013,0,0,0,12-12A12.014,12.014,0,0,0-216.109,694.4Zm0,23.04a11.053,11.053,0,0,1-11.04-11.04,11.053,11.053,0,0,1,11.04-11.04,11.053,11.053,0,0,1,11.04,11.04A11.053,11.053,0,0,1-216.109,717.445Z",
    transform: "translate(654.109 263.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.482,0l-7.1,7.249L1.518,3.311,0,4.862l5.385,5.5L14,1.562Z",
    transform: "translate(431 965)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApply);
export default __webpack_public_path__ + "static/media/icon-apply.ea1f6f98c59603d8698193ae8717c0f7.svg";
export { ForwardRef as ReactComponent };